import { BottomNavigation, BottomNavigationAction, Box, Container } from "@mui/material";
import { PaperCard } from "../../shared/ui/paper-card/paper-card.component";
import DateRangePicker from "../../shared/ui/date/date-range-picker.component";
import { LoadingButton } from "@mui/lab";
import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState } from "react";
import { CreatedFinishedBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/created-finished-barchart";
import { CreatedBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/created-barchart";
import { FinishedBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/finished-barchart";
import { BilledBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/billed-barchart";
import { UsePericiasByCostumerMetrics } from "../../features/pericia/get-pericias-metrics-by-costumer/api/usePericiasMetricsByCostumer";
import { NotBilledBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/not-billed-barchart";
import { NotDoneBarchart } from "../../features/pericia/get-pericias-metrics-by-costumer/ui/not-done-barchart";
import CostumerAutocompleteSearchBar from "../../entities/costumer/ui/costumer-autocomplete-search-bar.component";
import { Costumer, CreateNewCostumer } from "../../entities/costumer";
import { useNavigate } from "react-router-dom";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";

export const GetPericiasMetricsByCostumerPage = () => {
  const [costumer, setCostumer] = useState<Costumer>(CreateNewCostumer());
  const {
    metrics,
    searchProps,
    createdInfo,
    finishedInfo,
    billedInfo,
    timeFrame,
    costumerName,
    handleSetSearchProps,
    metricsByDay,
    metricsByWeek,
    metricsByMonth,
    metricsStartDate,
    metricsEndDate,
    isLoading,
    error
  } = UsePericiasByCostumerMetrics();
  const { startDate, endDate } = searchProps;

  const navigate = useNavigate();
  const [navItem, setNavItem] = useState(1);

  const handleNavigation = (event: React.SyntheticEvent, item: number) => {
    setNavItem(item);
    switch (item) {
      case 0:
        navigate("/pericias/metrics");
        break;
      case 1:
        break;
      case 2:
        navigate("/pericias/metrics/by-costumers");
        break;
      case 3:
        navigate("/pericias/metrics/profit");
        break;
      default:
        navigate("/");
    }
  };

  const handleDateChange = (start: Date, end: Date) => {
    handleSetSearchProps({ startDate: start, endDate: end, costumer });
  };

  const handleGenerateMetrics = () => {
    handleSetSearchProps({ enabled: true, costumer, startDate, endDate });
  };

  useEffect(() => {
    if (!error) return;
    toast.error("Erro ao gerar métricas...");
  }, [error]);

  return (
    <Container>
      <Box mb={5} />
      <BottomNavigation showLabels value={navItem} onChange={handleNavigation} sx={{ marginBottom: "2rem" }}>
        <BottomNavigationAction label="Métricas Nuovauto" icon={<EqualizerIcon />} />
        <BottomNavigationAction label="Métricas cliente" icon={<SignalCellularAltIcon />} />
        <BottomNavigationAction label="Métricas entre clientes" icon={<StackedBarChartIcon />} />
        <BottomNavigationAction label="Métricas faturamento" icon={<TrendingUpIcon />} />
      </BottomNavigation>
      <h1>Métricas por cliente</h1>
      <PaperCard title="Selecione o período">
        <CostumerAutocompleteSearchBar 
            value = {costumer}
            onChange={(c)=> setCostumer(c || {} as Costumer)} />
        <Box mb={3} />
        <DateRangePicker props={{ start: startDate, end: endDate, onChange: handleDateChange }} />
        <Box mb={3} />
        <LoadingButton fullWidth variant="contained" loading={isLoading} onClick={handleGenerateMetrics}>
          Gerar métricas
        </LoadingButton>
      </PaperCard>
      <Box mb={5} />
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByDay} style={{ marginRight: "2rem" }}>
        Métricas por dia
      </LoadingButton>
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByWeek} style={{ marginRight: "2rem" }}>
        Métricas por semana
      </LoadingButton>
      <LoadingButton variant="outlined" loading={isLoading} onClick={metricsByMonth}>
        Métricas por mes
      </LoadingButton>
      <Box mb={5} />
      {metrics.length > 0 && (
        <>
          <CreatedFinishedBarchart
            costumerName={costumerName}
            metrics={metrics}
            createdInfo={createdInfo}
            finishedInfo={finishedInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
          <CreatedBarchart
            costumerName={costumerName}
            metrics={metrics}
            createdInfo={createdInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
          <FinishedBarchart
            costumerName={costumerName}
            metrics={metrics}
            finishedInfo={finishedInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
          <BilledBarchart
            costumerName={costumerName}
            metrics={metrics}
            billedInfo={billedInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
          <NotBilledBarchart
            costumerName={costumerName}
            metrics={metrics}
            billedInfo={billedInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
          <NotDoneBarchart
            costumerName={costumerName}
            metrics={metrics}
            billedInfo={billedInfo}
            timeFrame={timeFrame}
            startDate={metricsStartDate}
            endDate={metricsEndDate}
          />
        </>
      )}
      <ToastContainer />
    </Container>
  );
};
